<script setup lang="ts" generic="Value, Content">
import InputCheckboxWithLabel from './InputCheckboxWithLabel.vue';

export type CheckBoxOption<Value, Content> = {
  value: Value;
  content: Content; // labelText or scopedSlot内でテンプレートを作るための情報
  disabled?: boolean;
};
const props = withDefaults(
  defineProps<{
    options: CheckBoxOption<Value, Content>[];
    modelValue: Value[];
    name: string;
    wrap?: boolean;
    disabled?: boolean;
  }>(),
  {
    wrap: false,
    disabled: false,
  }
);

const emit = defineEmits<{
  'update:modelValue': [value: Value[]];
}>();

const localState = computed({
  get: (): Value[] => props.modelValue,
  set(newValue) {
    emit('update:modelValue', newValue);
  },
});
</script>
<template>
  <ul
    :class="[
      $style.list,
      {
        [$style['list--wrap']]: props.wrap === true,
      },
    ]"
  >
    <li v-for="(option, i) in options" :key="i" :class="$style.list__item">
      <InputCheckboxWithLabel
        v-model="localState"
        :value="option.value"
        :name="name"
        :disabled="option.disabled === true"
      >
        <slot :content="option.content">
          {{ option.content }}
        </slot>
      </InputCheckboxWithLabel>
    </li>
  </ul>
</template>

<style lang="scss" module>
.list {
  display: flex;
  flex-direction: column;
  gap: 8px 16px;

  &--wrap {
    flex-direction: row;
    flex-wrap: wrap;
  }

  &__item {
    flex-shrink: 0;
  }
}
</style>
